import { hairColorList } from "../helper";
import FilterMultiSelectBox from "./filterMultiSelectBox";
import { useHairColorFilter } from "../filters/useHairColorFilter";

const FilterHairColor = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    values,
    setValues,
    isDisabled,
    buildHairColorFilter,
  } = useHairColorFilter(talentFilter, talentFilterTags);

  const handleAdd = () => {
    const payload = buildHairColorFilter();
    if (!payload) return;

    onAddFilter("hair_color", payload);
  };

  return (
    <FilterMultiSelectBox
      title="HAIR COLOR (Select one or several)"
      label="Select hair color or search"
      list={hairColorList}
      selectedValue={values}
      onChange={setValues}
      onAddFilter={handleAdd}
      btnContent="Add Filter"
      disabled={isDisabled}
    />
  );
};

export default FilterHairColor;
